import axios from '@axios'

const route = 'financial/revenue'

export default {
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {
    getAll(context, {
      itemsPerPage, page, status, date, filters,
    }) {
      return axios.post(
        `${route
        }/index?page=${
          page
        }&items_per_page=${
          itemsPerPage
        }&status=${
          status
        }&due_date_start=${
          date[0]
        }&due_date_end=${
          date[1]}`,
        filters,
      )
    },

    store(context, billsToPay) {
      return axios.post(route, billsToPay)
    },

    update(context, billsToPay) {
      return axios.put(`${route}/${billsToPay.id}`, billsToPay)
    },

    destroy(context, billsToPay) {
      return axios.delete(`${route}/${billsToPay.id}`)
    },

    getSupplier(context, searchKeyWordSupplier) {
      return axios.get(`${route}/get_suppliers?search=${searchKeyWordSupplier}`)
    },

    // pagar contas
    payBills(context, bills) {
      return axios.post(`${route}/pay_bills`, { bills })
    },

    pay(context, bills) {
      return axios.post(`${route}/pay`, bills)
    },
    cancel(context, bill) {
      return axios.post(`${route}/cancel/${bill.id}`)
    },
    recycle(context, bill) {
      return axios.post(`${route}/recycle/${bill.id}`)
    },
    getDownloadAttach(context, bill) {
      return axios.get(`${route}/download_attach/${bill.id}`, { responseType: 'blob' })
    },
    saveCategory(context, category) {
      return axios.post('financial/revenue/store_revenue_category', category)
    },
    exportExcel(context, payload) {
      return axios.post(`${route}/export_excel`, payload, { responseType: 'blob' })
    },
  },
}
